<template>
    <section class="gmp-section gmp-mb-l">
        <div class="two-column-tout">
            <div class="h-c-page">
                <div class="h-c-grid">
                    <div class="h-c-grid__col h-c-grid__col-xl--offset-1 h-c-grid__col-l--6
            h-c-grid__col-xl--5 h-c-grid__col-l--order-2 h-c-grid__col--align-middle
            two-column-tout__content">
                        <h3 class="h-c-headline h-c-headline--one">
                            全面解决各类供货需求
                        </h3>
                        <div class="h-u-mb-std two-column-tout__description">
                            <p>供货商的规模和销售产品各异，订货方式也多种多样。我们专为不同规模的供货商开发了定制化的微信小程序产品，助您更高效地接单、管理和配送</p>
                        </div>
                        <a href="/market" class="h-c-link h-c-link--internal gmp-link">查看餐饮供货解决方案</a>
                    </div>

                    <div class="h-c-grid__col
          h-c-grid__col-l--6 h-c-grid__col-l--order-1 h-c-grid__col--align-middle">
                        <div class="two-column-tout__image text-center">
                            <picture>
                                <img src="@/assets/img/sales.png" alt="" class="gmp-no-grab ">
                            </picture>
                        </div>
                    </div>

                </div>
            </div>
        </div>

    </section>
</template>

<script>
    export default {
        name: "TwoTout"
    }
</script>

<style lang="less">




</style>